export const INDEXED_BLOCK_STALE_TIME_MS = 30_000

type IndexedBlockResponse = {
  _meta?: {
    block?: {
      number?: number | string | null
    } | null
  } | null
}

export const capBlocksToLatestIndexedBlock = (blocks: Map<number, number>, latestIndexedBlock?: number) => {
  if (latestIndexedBlock === undefined || !Number.isFinite(latestIndexedBlock) || blocks.size === 0) {
    return blocks
  }

  let hasClampedBlock = false
  const cappedBlocks = new Map<number, number>()

  blocks.forEach((blockNumber, timestamp) => {
    const nextBlockNumber = Math.min(blockNumber, latestIndexedBlock)
    if (nextBlockNumber !== blockNumber) {
      hasClampedBlock = true
    }
    cappedBlocks.set(timestamp, nextBlockNumber)
  })

  return hasClampedBlock ? cappedBlocks : blocks
}

export const getLatestIndexedBlockNumber = (response?: IndexedBlockResponse | null): number | undefined => {
  const blockNumber = Number(response?._meta?.block?.number)
  return Number.isFinite(blockNumber) ? blockNumber : undefined
}
